import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c6a13e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "super-sview-class" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.isSixin)
      ? (_openBlock(), _createBlock($setup["ChatView"], {
          key: 0,
          id: $setup.zb_chatkey,
          "auto-msg": "",
          onPrivateGoback: $setup.priviteGoback
        }, null, 8 /* PROPS */, ["id"]))
      : (_openBlock(), _createBlock($setup["Message"], {
          key: 1,
          jumpType: 2,
          isGroup: 2,
          onTochat: $setup.tochat
        }))
  ]))
}